import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgToggleOn = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 15 7.5",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.25 0H3.75C1.68 0 0 1.68 0 3.75C0 5.82 1.68 7.5 3.75 7.5H11.25C13.32 7.5 15 5.82 15 3.75C15 1.68 13.32 0 11.25 0ZM11.25 6C10.005 6 9 4.995 9 3.75C9 2.505 10.005 1.5 11.25 1.5C12.495 1.5 13.5 2.505 13.5 3.75C13.5 4.995 12.495 6 11.25 6Z",
		fill: "currentColor"
	})
});
export default SvgToggleOn;
